<template>
    <div class="header_wrapper">
      <div class="header">
        <router-link :to="{ path:'/'}" class="logo_desktop">
            <prismic-image :field="logo" class="logo"/>
        </router-link>
        <router-link :to="{ path:'/'}" class="logo_mobile">
            <img src="/showconcept_white_logo.svg" class="logo">
        </router-link>        
        <div class="menu">
            <div class="hamburger"><div class="bar"></div></div>
            <div class="menu_label">{{ $prismic.richTextAsPlain(menu_label) }}</div>
        </div>
        <a class="header_kontakt" href="mailto:robert@showconcept.co">
          <div class="kontakt_button black_button"><span>{{ $prismic.richTextAsPlain(kontakt_label) }}</span></div>
        </a>
      </div>

      <!-- meni on click -->
      <div class="menu_wrapper_wide">
        <div class="menu_wrapper"> 
          <div class="menu_items">
            <menus></menus>
          </div>
        </div> <!-- end menu wrapper -->

        <div class="below_menu">
          <div class="below_menu_inner">
            <div class="below_menu_left">
              <div class="below_menu_mail"><a href="mailto:robert@showconcept.co">robert@showconcept.co</a></div>
              <div class="below_menu_tel">+385 98 316 555</div>
            </div>  
            <div class="below_menu_right">
              <div class="below_menu_facebook">
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="50" height="50" viewBox="0 0 50 50">
                    <defs>
                        <path id="a" d="M31.49 12.68v3.967h-2.358c-.862 0-1.443.18-1.743.54-.3.361-.45.902-.45 1.623v2.84h4.401l-.586 4.447h-3.816V37.5h-4.597V26.097H18.51V21.65h3.83v-3.276c0-1.863.522-3.307 1.563-4.334 1.042-1.027 2.43-1.54 4.162-1.54 1.472 0 2.614.06 3.425.18z"/>
                    </defs>
                    <g fill="none" fill-rule="evenodd">
                        <mask id="b" fill="#fff">
                            <use xlink:href="#a"/>
                        </mask>
                        <use fill="#000" xlink:href="#a"/>
                        <g fill="#27272F" mask="url(#b)">
                            <path d="M0 0h50v50H0z"/>
                        </g>
                    </g>
                </svg>
              </div>
            </div>
          </div>  <!-- end bellow menu inner -->
        </div><!-- end below menu -->

      </div> <!-- end menu wrapper wide -->
    
    </div><!-- end header wrapper  -->
</template>

<script>
import $ from 'jquery'
import Menus from './Menu.vue'

export default {
  name: 'Top',
  data () {
    return {
      logo:null,
      menu_label:null,
      kontakt_label:null
    }
  },
  methods: {

    getContent () {
      //homepage general data
      this.$prismic.client.getSingle('header')
        .then((document) => {
          if (document) {
            this.logo = document.data.logo
            this.menu_label = document.data.menu_label
            this.kontakt_label = document.data.kontakt_label
          } else {
            this.$router.push({ name: 'not-found' })
          }
        })
    },

    menu() {
        (function () {
            $('.menu').on('click', function() {
              $('.bar').toggleClass('animate');
              $('.menu_wrapper_wide').toggleClass('show');
                if($('.menu_wrapper_wide').hasClass('show')){
                  $('.home_wrapper').css('display','none');
                  $('.page_wrapper').css('display','none');
                  $('.single_post_wrapper').css('display','none');
                  $('.footer_wrapper').css('display','none');
                  $('.archive-wrapper').css('display','none');
                }
                if(!$('.menu_wrapper_wide').hasClass('show')){
                  $('.home_wrapper').css('display','block');
                  $('.page_wrapper').css('display','block');
                  $('.single_post_wrapper').css('display','block');
                  $('.footer_wrapper').css('display','flex');
                  $('.archive-wrapper').css('display','block');
                }               
            })
        })();
        //close when click on menu item
        $('.header_wrapper a .menu_item').click(function() {
          $(".menu").click();
         });

    }

  },
  mounted () {
    this.getContent();
    this.menu();
  },
  components:{
    Menus
  }  

}
</script>